import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from 'components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class CanceledByOwnerTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `canceledByOwnerTasksList`,
      queryParamsStatic: {
        status: 8
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(CanceledByOwnerTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/CanceledByOwnerTasksList/CanceledByOwnerTasksList.js